import React from "react";
import { Badge, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StudentStatus = (props) => {
  let statusClass = null;
  let statusIcon = null;

  if (props.status === null) {
    return <div />;
  }
  if (props.status === "InProgress") {
    statusClass = "bg-warning theme-color text-white float-end";
    statusIcon = null;
  }
  if (props.status === "Done" && !props.clickable) {
    statusClass = "bg-success theme-color text-white float-end";
    statusIcon = <FontAwesomeIcon className="float-start" icon="check" />;
  }
  if (props.status === "Done" && props.clickable) {
    statusClass = "bg-success theme-color text-white float-end";
    statusIcon = <FontAwesomeIcon style={{ marginRight: "3%" }} icon="check" />;
  }

  if (props.status === "Completed") {
    statusClass = "bg-primary theme-color text-white float-end";
    statusIcon = null;
  }
  if (props.clickable) {
    return (
      <Button
        size="sm"
        className={statusClass}
        style={{
          width: props.fullWidth ? "100%" : "",
          padding: "0",
          margin: "0",
          fontSize: ".8em",
          height: "100%",
        }}
      >
        {statusIcon}
        <small>
          <FormattedMessage id={props.status} />
        </small>
      </Button>
    );
  } else {
    return (
      <Badge
        pill
        className={statusClass}
        style={
          props.status === "NotStarted"
            ? { display: "none" }
            : { width: props.fullWidth ? "100%" : "" }
        }
      >
        {statusIcon}
        <small>
          <FormattedMessage id={props.status} />
        </small>
      </Badge>
    );
  }
};

export default StudentStatus;
